export { default } from './Table';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Table/index.js
// module id = 561
// module chunks = 2